/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationSpotJobPosition = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationSpotJobPosition"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        d="M56.78 56.69c4.45-2.74 7.31-7.64 7.31-13.07 0-8.47-6.89-15.36-15.36-15.36-1.05 0-2.1.11-3.13.33a15.32 15.32 0 0 0 4.75-11.09c0-8.47-6.89-15.36-15.36-15.36S19.63 9.03 19.63 17.5c0 4.63 2.09 8.88 5.47 11.73-1.7-.63-3.5-.96-5.35-.96-8.47 0-15.36 6.89-15.36 15.36 0 5.36 2.8 10.22 7.18 12.98-1.1.82-1.99 1.79-2.6 2.89l-.98 1.75 4.36 2.44.98-1.75c.94-1.67 3.42-2.83 6.18-2.87h.17c2.81 0 5.16 1.1 6.27 2.94l1.03 1.71 4.28-2.59-1.03-1.71c-.64-1.05-1.46-1.97-2.44-2.74a15.3 15.3 0 0 0 6.43-7.96c1.15 3.25 3.38 6.04 6.3 7.88-1.1.82-1.99 1.79-2.6 2.89l-.98 1.75 4.36 2.44.98-1.75c.94-1.67 3.42-2.83 6.18-2.87h.13c2.84 0 5.21 1.1 6.32 2.94l1.04 1.71 4.28-2.59-1.03-1.71c-.63-1.04-1.46-1.96-2.45-2.73z"
      />
      <path
        fill="#B7E854"
        d="M35 30.36c7.102 0 12.86-5.758 12.86-12.86S42.102 4.64 35 4.64 22.14 10.398 22.14 17.5 27.898 30.36 35 30.36"
      />
      <path
        fill="#27DBA8"
        d="M19.76 56.48c7.102 0 12.86-5.758 12.86-12.86s-5.758-12.86-12.86-12.86S6.9 36.518 6.9 43.62s5.758 12.86 12.86 12.86M48.73 56.48c7.102 0 12.86-5.758 12.86-12.86s-5.758-12.86-12.86-12.86-12.86 5.758-12.86 12.86 5.758 12.86 12.86 12.86"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M38.79 14.95c1.12 0 2.12.49 2.8 1.28-.68.78-1.68 1.28-2.8 1.28s-2.12-.49-2.8-1.28c.68-.78 1.68-1.28 2.8-1.28M31.24 14.95c1.12 0 2.12.49 2.8 1.28-.68.78-1.68 1.28-2.8 1.28s-2.12-.49-2.8-1.28c.68-.78 1.68-1.28 2.8-1.28M23.56 41.08c1.12 0 2.12.49 2.8 1.28-.68.78-1.68 1.28-2.8 1.28s-2.12-.49-2.8-1.28c.68-.78 1.68-1.28 2.8-1.28M16 41.08c1.12 0 2.12.49 2.8 1.28-.68.78-1.68 1.28-2.8 1.28s-2.12-.49-2.8-1.28c.68-.78 1.68-1.28 2.8-1.28M52.53 41.08c1.12 0 2.12.49 2.8 1.28-.68.78-1.68 1.28-2.8 1.28s-2.12-.49-2.8-1.28c.68-.78 1.68-1.28 2.8-1.28M44.97 41.08c1.12 0 2.12.49 2.8 1.28-.68.78-1.68 1.28-2.8 1.28s-2.12-.49-2.8-1.28c.68-.78 1.68-1.28 2.8-1.28"
        clipRule="evenodd"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M35.04 20.55c-.94 0-1.7-.76-1.7-1.7h1c0 .39.31.7.7.7s.7-.31.7-.7h1c0 .94-.76 1.7-1.7 1.7M19.81 46.67c-.94 0-1.7-.76-1.7-1.7h1c0 .39.31.7.7.7s.7-.31.7-.7h1c0 .94-.76 1.7-1.7 1.7M48.78 46.67c-.94 0-1.7-.76-1.7-1.7h1c0 .39.31.7.7.7s.7-.31.7-.7h1c0 .94-.76 1.7-1.7 1.7"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        fillRule="evenodd"
        d="M55.61 42.11c-.78-.89-1.9-1.4-3.08-1.4s-2.3.51-3.08 1.4l-.21.25.21.25c.78.89 1.9 1.4 3.08 1.4s2.3-.51 3.08-1.4l.21-.25zm-5.36.24c.86-.8 2.13-1.03 3.24-.72-.23.16-.39.42-.39.72s.16.56.39.72c-1.11.32-2.38.09-3.24-.72M44.97 40.7c-1.18 0-2.3.51-3.08 1.4l-.21.25.21.25c.78.89 1.9 1.4 3.08 1.4s2.3-.51 3.08-1.4l.21-.25-.21-.25c-.78-.89-1.9-1.4-3.08-1.4m-2.28 1.65c.86-.8 2.13-1.03 3.24-.72-.23.16-.39.42-.39.72s.16.56.39.72c-1.11.32-2.38.09-3.24-.72M41.87 15.98c-.78-.89-1.9-1.4-3.08-1.4s-2.3.51-3.08 1.4l-.21.25.21.25c.78.89 1.9 1.41 3.08 1.41s2.3-.51 3.08-1.41l.21-.25zm-5.35.25c.86-.8 2.13-1.03 3.24-.72-.23.16-.39.42-.39.72s.16.56.39.72c-1.11.32-2.38.09-3.24-.72M31.24 14.58c-1.18 0-2.3.51-3.08 1.4l-.21.25.21.25c.78.89 1.9 1.41 3.08 1.41s2.3-.51 3.08-1.41l.21-.25-.21-.25c-.78-.89-1.9-1.4-3.08-1.4m-2.28 1.65c.86-.8 2.13-1.03 3.24-.72-.23.16-.39.42-.39.72s.16.56.39.72c-1.11.32-2.38.09-3.24-.72M26.64 42.11c-.78-.89-1.9-1.4-3.08-1.4s-2.3.51-3.08 1.4l-.21.25.21.25c.78.89 1.9 1.4 3.08 1.4s2.3-.51 3.08-1.4l.21-.25zm-5.36.24c.86-.8 2.13-1.03 3.24-.72-.23.16-.39.42-.39.72s.16.56.39.72c-1.11.32-2.38.09-3.24-.72M16 40.7c-1.18 0-2.3.51-3.08 1.4l-.21.25.21.25c.78.89 1.9 1.4 3.08 1.4s2.3-.51 3.08-1.4l.21-.25-.21-.25c-.78-.89-1.9-1.4-3.08-1.4m-2.28 1.65c.86-.8 2.13-1.03 3.24-.72-.23.16-.39.42-.39.72s.16.56.39.72c-1.11.32-2.38.09-3.24-.72"
        clipRule="evenodd"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M62.09 43.63c0-7.37-5.99-13.36-13.36-13.36-2.51 0-4.85.71-6.86 1.92-.98-.8-2.16-1.4-3.48-1.78 5.72-1.51 9.96-6.71 9.96-12.9 0-7.37-5.99-13.36-13.36-13.36s-13.36 5.99-13.36 13.36c0 6.18 4.22 11.37 9.93 12.89-1.65.46-3.1 1.24-4.2 2.26a13.3 13.3 0 0 0-7.6-2.39c-7.37 0-13.36 5.99-13.36 13.36 0 6.18 4.22 11.38 9.93 12.9-2.5.68-4.56 2.08-5.61 3.95l.87.49c1.29-2.31 4.39-3.84 7.9-3.9 3.63-.06 6.67 1.4 8.19 3.91l.86-.52c-1.15-1.91-3.1-3.24-5.47-3.91 5.76-1.48 10.04-6.7 10.04-12.92 0-4.18-1.93-7.91-4.95-10.36 1.58-1.4 3.95-2.28 6.56-2.32h.21c2.35 0 4.45.66 6.03 1.83-3.39 2.43-5.6 6.38-5.6 10.86 0 6.18 4.22 11.38 9.93 12.9-2.5.68-4.56 2.08-5.61 3.95l.87.49c1.29-2.31 4.39-3.84 7.9-3.9 3.61-.06 6.67 1.4 8.19 3.91l.86-.52c-1.15-1.91-3.09-3.25-5.45-3.91 5.76-1.49 10.03-6.71 10.03-12.92zm-29.97 0c0 6.81-5.54 12.36-12.36 12.36S7.4 50.45 7.4 43.63s5.54-12.36 12.36-12.36 12.36 5.54 12.36 12.36M22.64 17.5c0-6.81 5.54-12.36 12.36-12.36s12.36 5.54 12.36 12.36S41.82 29.86 35 29.86 22.64 24.32 22.64 17.5m26.09 38.48c-6.81 0-12.36-5.54-12.36-12.36s5.54-12.36 12.36-12.36 12.36 5.54 12.36 12.36-5.54 12.36-12.36 12.36"
      />
    </svg>
  );
};
export default IllustrationSpotJobPosition;
